module.exports = __webpack_public_path__ + "static/media/post-12.ba8f0f95.jpg";